import { useCurrentUser } from 'src/services/user/userService'
import UserMenu from './UserMenu';
import classes from './TopMenu.module.scss';
import { useAtom } from 'jotai';
import WaitRipple from '../WaitRipple';
import CoursePartMenu from './CoursePartMenu';
import LnIcon from '../LnIcon';
import CourseMenu from './CourseMenu';
import { waitRippleAtom } from 'src/services/WaitRippleService';
import { textReadyAtom } from 'src/utils/languageService';
import LanguageMenu from '../LanguageMenu/LanguageMenu';
import { useI18n } from 'src/utils/lni18n';
import { loginService } from 'src/login/LoginService';
import ManualsMenu from '../LanguageMenu/ManualsMenu';



export default function TopMenu(props: { setOpenSideBar: (state: boolean) => void }) {
    const { currentUser } = useCurrentUser();
    const { languageService: t } = useI18n();

    const [waitRipple] = useAtom(waitRippleAtom);
    const [textReady] = useAtom(textReadyAtom);




    return (
        <>
            <div className={`ml-5 p-2 flex gap-2 text-lg d-flex align-items-center ${classes.topmenu}`}>
                {waitRipple && <WaitRipple />}

                <div className='toggle'>
                    <button className='btn btn-link p-3' onClick={() => props.setOpenSideBar(true)}>
                        <LnIcon name="next-2" className='icon-small' />
                    </button>
                </div>

                {textReady && currentUser === null && <button type='button' onClick={() => loginService.setOpenDialog(true)} className='ml-auto mt-2 mr-2 btn btn-small btn-warning'>{t.getText("login")}</button>}

                {textReady && currentUser && <>
                    <div className="d-flex flex-wrap" >
                        <div className='mr-3'>
                            <CoursePartMenu />
                        </div>
                        <CourseMenu />
                    </div>



                    <div className="ml-auto d-flex pr-4" >

                        <div className="mr-5 mt-2">
                            <ManualsMenu caretClass={"white-caret"} />
                        </div>

                        <div className="mr-5 mt-2">
                            <LanguageMenu caretClass={"white-caret"} />
                        </div>
                        <UserMenu />


                    </div>
                </>}

            </div>


        </>
    )
}
